import { IsLocale, IsNotEmpty, IsString } from "@leavy/validator";
import { Query, RpcInvocable } from "@leavy/cq-core";
import { Bad, OkVal } from "@leavy/result";
import { HOMESHARING_BACKEND_SERVICE_NAME } from "../../base";
import { ListingId } from "../domain/Listing";
import { HouseListingQueryResult } from "../model/ListingQueryResult";

export type GetHouseListingByIdQueryResult =
    | OkVal<HouseListingQueryResult>
    | OkVal<null>
    | Bad<"INVALID_ID">;

@RpcInvocable({
    namespace: HOMESHARING_BACKEND_SERVICE_NAME,
    alias: "get_house_listing_by_id_query",
})
export class GetHouseListingByIdQuery extends Query<GetHouseListingByIdQueryResult> {
    @IsLocale()
    locale!: string;

    @IsString()
    @IsNotEmpty()
    listingId!: ListingId;
}
